import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import PeriodEdit from './PriceEdit';
import PeriodCreate from './PriceCreate';

export default {
  icon: MonetizationOnIcon,
  edit: PeriodEdit,
  create: PeriodCreate,
};
